import {OrthographicCamera, Vector3, WebGLRenderer} from 'three'

export const camera = new OrthographicCamera(-1, 1, 1, -1, 0.1, 3000)
camera.position.z = 1200
camera.lookAt(new Vector3(0, 0, 0))
camera.updateProjectionMatrix()

let _renderer: WebGLRenderer | null = null

export const setRenderer = (renderer: WebGLRenderer) => {
  _renderer = renderer
}

export const getRenderer = () => {
  if (!_renderer) throw new Error('Renderer not set')
  return _renderer
}
